/**
 * StatusChip — чип статуса платежа. Цвета — из theme.css (.pw-status--*), метка — из STATUS_META.
 * Несёт текстовую метку (не только цвет) для различимости при дальтонизме; role="status".
 */

import type { PaymentStatus } from '../../lib/types';
import { STATUS_META } from './lib/status';
import { cx } from './ui/cx';

export interface StatusChipProps {
  status: PaymentStatus;
  className?: string;
}

export function StatusChip({ status, className }: StatusChipProps): JSX.Element {
  const meta = STATUS_META[status];
  return (
    <span className={cx('pw-status', `pw-status--${meta.tone}`, className)} role="status" aria-label={meta.label}>
      <span className="pw-status__dot" aria-hidden />
      {meta.label}
    </span>
  );
}
